import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useInnerBlocksProps, useBlockProps } from '@wordpress/block-editor';
export default function QuerySave(_ref) {
  let {
    attributes: {
      tagName: Tag = 'div'
    }
  } = _ref;
  const blockProps = useBlockProps.save();
  const innerBlocksProps = useInnerBlocksProps.save(blockProps);
  return createElement(Tag, innerBlocksProps);
}
//# sourceMappingURL=save.js.map